import { useState, FC } from 'react';
import Typography from '@mui/material/Typography';
import { IconButton, List, ListItem } from '@mui/material';
import { CheckCircle, Cancel } from '@mui/icons-material';
import { IResultAccordionsProps } from './types';
import { Accordion, AccordionDetails, AccordionSummary } from './styles';
import { IEligibilityResult } from 'hooks/useEligibility/types';
import { FormattedMessage } from 'react-intl';

export const ResultAccordions: FC<IResultAccordionsProps> = ({ items }) => {
  const [expanded, setExpanded] = useState<string>('panel1');

  const changeHandler = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : '');
  };

  const messagesList = [
    { messageId: 'accordion.explanation', valueKey: 'explanation' },
    { messageId: 'accordion.investigation', valueKey: 'investagation' },
    { messageId: 'accordion.input', valueKey: 'input' },
  ];

  return (
    <div>
      {items.map(row => (
        <Accordion key={row.rule} expanded={expanded === row.rule} onChange={changeHandler(row.rule)}>
          <AccordionSummary aria-controls={row.rule} id={row.rule}>
            <Typography component={'span'}>{row.rule}</Typography>
            {row.isPassed ? (
              <IconButton aria-label='fingerprint' color='success'>
                <CheckCircle />
              </IconButton>
            ) : (
              <IconButton aria-label='fingerprint' color='error'>
                <Cancel />
              </IconButton>
            )}
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {messagesList.map(({ messageId, valueKey }) => (
                <ListItem disablePadding className={'m-1 grid grid-cols-4'} key={messageId}>
                  <div className={'col-span-1'}>
                    <FormattedMessage id={messageId} />
                  </div>
                  <div className={'col-span-3 text-sm text-slate-500'}>{row[valueKey as keyof IEligibilityResult]}</div>
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};
